var exports = {
  "copilotAvatar": "copilotAvatar__JzKA0x",
  "small": "small__FVt0Mn",
  "medium": "medium__o5dgpc",
  "large": "large__tkyqpA",
  "defaultStyle": "defaultStyle__XjbfRy",
};

__webpack_require__.r(module.exports = exports);
